module.exports = __webpack_public_path__ + "img/joinUs_content4.d4f19033.png";